// extracted by mini-css-extract-plugin
export default {"dropdown":"app-title-bar-dropdown-menu_dropdown__7qD8s","hidden":"app-title-bar-dropdown-menu_hidden__zE5sf"};